/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AICreateCustomBookingMethodsRequest {
  prompt_history?: Prompt[];
  raw_custom_booking_methods?: string;
}

export interface AICreateCustomBookingMethodsResponse {
  custom_booking_methods?: CustomBookingMethod[];
  response?: Prompt;
}

export interface AddParcelRequest {
  /**
   * Parcel details contains information about the parcel. If not provided the first existing parcel will be duplicated. [optional]
   * ParcelDetails contains additional information about parcels. Represents the non-output-only
   * subset of Shipment Parcels.
   */
  parcel?: ParcelDetails;
  shipment_id?: string;
  site_id?: string;
}

export interface AddParcelResponse {
  /**
   * Shipment is the top level object in SOM. A shipment can be composed of
   * multiple parcels and each parcel can contain many deliveries. Only one
   * delivery can be active at a time.
   */
  shipment?: Shipment;
}

/** Describes an additional service provided by shipping method. */
export interface Addon {
  /** External code, as defined in carrier's system. */
  code?: string;
  /** Additional data that has to be passed to use the addon. */
  data?: Record<string, string>;
  /** Description of the addon. */
  description?: string;
  /** Internal identifier of an addon. */
  name?: string;
}

/** Common address entity that used almost everywhere in Ingrid's API. */
export interface Address {
  /** List of address lines part of address such as street and building number */
  address_lines?: string[];
  /** Number of the apartment. */
  apartment_number?: string;
  /**
   * Attention field. Can be used to indicate an employee if the address is a
   * company address [optional]
   */
  attn?: string;
  /** in the UK some buildings do not have a number, only a name */
  building_name?: string;
  /** Care of part of address usually written as `c/o` [optional] */
  care_of?: string;
  /** Name of the city */
  city?: string;
  /**
   * Geolocation coordinates of the address. If reverse geolocation lookup of the
   * address was successful this property will be populated. If coordinates are
   * available they will be used to in service point search. In case of
   * `search_address` coordinates can also be set by merchant if known.
   */
  coordinates?: Coordinates;
  /**
   * Country should be specified as two uppercase letters (ISO Alpha-2).
   * Example `SE` for Sweden, `ES` for Spain.
   */
  country?: string;
  /** The door code to the main entrance of the building if applicable [optional] */
  door_code?: string;
  /** Floor number [optional] */
  floor_number?: string;
  /** Customer or company name */
  name?: string;
  /** ID of the PO Box [optional] */
  po_box_id?: string;
  /** Postal code (or zipcode in US) */
  postal_code?: string;
  /** Region can be a state or a province [optional] */
  region?: string;
  /** Name of the street. */
  street?: string;
  /** Number of the street. */
  street_number?: string;
  /**
   * Further division of regions. Example countries are GB, IE, IT, LT, MX
   * For example for The Republic Of Ireland there are 4 provinces (regions),
   * e.g. `Connacht` and 26 counties (subregions), e.g. `Galway`
   * Format is ISO 3166 where applicable, exceptions are e.g. Mexico [optional]
   */
  subregion?: string;
}

export interface Any {
  "@type"?: string;
  [key: string]: any;
}

export interface BatchGetConsolidatedShipmentResponse {
  consolidated_shipments?: ConsolidatedShipment[];
}

export interface BookConsolidatedShipmentRequest {
  /** [required] Consolidated Shipment ID that is to be booked. */
  consolidated_shipment_id?: string;
  /** Holds information about customs declaration for the consolidated shipment. */
  customs_declaration?: CustomsDeclaration;
  /** [optional] Shipment metadata tags. Any new ones will be added. */
  meta?: Record<string, string>;
  /**
   * [required] Pallets included in the shipment.
   * The length of the array corresponds to the number of pallets.
   */
  pallets?: Pallet[];
}

export interface BookConsolidatedShipmentResponse {
  consolidated_shipment?: ConsolidatedShipment;
}

export interface BookParcelsBulkRequest {
  /** The IDs of the shipments which parcels should be booked. */
  shipment_ids: string[];
}

export interface BookParcelsBulkResponse {
  /** The IDs of the shipments which parcels failed to book. */
  failed_shipment_ids?: string[];
  /** The IDs of the shipments which parcels successfully booked. */
  succeeded_shipment_ids?: string[];
}

/**
 * Perform a booking request to generate tracking numbers, shipping
 * labels and tracking links.
 */
export interface BookParcelsRequest {
  /** The ID of the shipment which parcels should be booked. [required] */
  shipment_id?: string;
}

/**
 * Returns latest shipment state together with generated shipping
 * labels, tracking numbers and tracking links.
 */
export interface BookParcelsResponse {
  /**
   * Current shipment object state
   * Shipment is the top level object in SOM. A shipment can be composed of
   * multiple parcels and each parcel can contain many deliveries. Only one
   * delivery can be active at a time.
   */
  shipment?: Shipment;
}

/** Book a pickup with the shipping company. */
export interface BookPickupRequest {
  /** Tracking number of the delivery which should be booked. [required] */
  tracking_number?: string;
}

/** Returns the state of the booked delivery. */
export interface BookPickupResponse {
  /**
   * Booked delivery state
   * Delivery is the parcel with start and end destination. A delivery always
   * has one parcel that it belongs to.
   */
  delivery?: Delivery;
}

/** @default "UNKNOWN" */
export type BookingMethodStatus = "UNKNOWN" | "DRAFT" | "PUBLISHED" | "ARCHIVED";

/** Represents a delivery that is or has to be booked. */
export interface BookingRecord {
  executed_at?: string;
  ftp_name?: string;
  id?: string;
  site_id?: string;
  /** Represents a booking strategy used by a delivery. */
  strategy?: Strategy;
  tracking_number?: string;
  url?: string;
}

/** Request to cancel a delivery if the shipment has not been picked up yet. */
export interface CancelDeliveryRequest {
  /** Delivery ID */
  id?: string;
  /** Delivery tracking number */
  tracking_number?: string;
}

/** Request to cancel a shipment if the shipment has not been picked up yet. */
export interface CancelShipmentRequest {
  /** Shipment ID */
  shipment_id?: string;
}

export interface ConsolidatedShipment {
  /** [optional] ID of the carrier contract to be used for booking. */
  carrier_contract_id?: string;
  /**
   * [output] Status of the consolidated shipment.
   * Status status = 14;
   * [output] Timestamp when consolidated shipment was created. RFC-3339 format.
   */
  created_at?: string;
  /** Holds information about customs declaration for the consolidated shipment. */
  customs_declaration?: CustomsDeclaration;
  /** [output] URL of the consolidated shipment's documents. */
  documents?: ConsolidatedShipmentDocuments[];
  /** [optional] External ID of the shipment. Can be used to store a unique identifier from the merchant. */
  external_id?: string;
  /** [required] Address where the shipment will be dispatched from. Most often the address of the warehouse. */
  from?: Party;
  /** [output] ID of the shipment (uuid). */
  id?: string;
  /** [optional] Shipment metadata tags */
  meta?: Record<string, string>;
  /** [required] Pallets included in the shipment. The length of the array corresponds to the number of pallets. Must include at least one pallet */
  pallets?: Pallet[];
  /** [output] IDs of the shipments that are part of the consolidated shipment. Shipments are added when booking them */
  shipment_ids?: string[];
  /** [required] Date when the shipment will most likely be dispatched from the warehouse. RFC-3339 format. */
  shipping_date?: string;
  /** [required] Shipping method for the consolidated shipment */
  shipping_method?: string;
  /** [output] Site ID to which the shipment belongs to. */
  site_id?: string;
  /** [output] Status of the shipment */
  status?: ConsolidatedShipmentStatus;
  /** [required] Destination address. For example address of the distribution center of the carrier. */
  to?: Party;
  /** [output] Tracking number for the consolidated shipment. */
  tracking_number?: string;
  /** [optional]  Defines who is billed for freight/transport charges. */
  transport_payer?: Payer;
  /** [output] Timestamp when consolidated shipment was last updated. RFC-3339 format. */
  updated_at?: string;
}

/** ConsolidatedShipmentDetails contains the details of a Consolidated Shipment that this shipment can be a part of. */
export interface ConsolidatedShipmentDetails {
  /** [Required] ID of the consolidated shipment that this shipment is part of. */
  consolidated_shipment_id?: string;
}

export interface ConsolidatedShipmentDocuments {
  /** Id of the document. Might be useful for returning CMR/Waybill number */
  id?: string;
  /** Name of the document */
  name?: string;
  /** Type of the document */
  type?: ConsolidatedShipmentDocumentsDocumentType;
  /** The url that points to the document */
  url?: string;
}

/** @default "DOCUMENT_UNKNOWN" */
export type ConsolidatedShipmentDocumentsDocumentType = "DOCUMENT_UNKNOWN" | "INVOICE" | "CMR" | "TRANSPORT_LABEL";

export interface ConsolidatedShipmentStatus {
  /** Used to attach a message to the current status. [optional] */
  message?: string;
  /** The type of the status. Used to determine the state of the shipment. [required] */
  type?: ConsolidatedShipmentStatusStatusType;
}

/**
 * - CREATED: CREATED is the initial state of the consolidated shipment.
 *  - BOOKED: BOOKED indicates that consolidated shipment has been booked, also known as having a label generated for it.
 *  - CANCELED: CANCELED indicates that the delivery has been suspended and will not proceed.
 *  - INVALID_BOOKING: INVALID_BOOKING indicates that a booking failed due to a bad request to the carrier service.
 *  - CANCEL_FAILED: CANCEL_FAILED indicates that the shipment could not be canceled by the carrier
 * @default "UNKNOWN"
 */
export type ConsolidatedShipmentStatusStatusType =
  | "UNKNOWN"
  | "CREATED"
  | "BOOKED"
  | "CANCELED"
  | "INVALID_BOOKING"
  | "CANCEL_FAILED";

/** For internal use [internal] */
export interface ConsolidatedShipmentsFiltering {
  /** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
  created_at_range?: DateTimeRange;
  id?: string;
  /** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
  shipping_date_range?: DateTimeRange;
  shipping_methods?: string[];
  statuses?: ConsolidatedShipmentStatusStatusType[];
}

/**
 * Contents contains all goods sent in a Shipment or Parcel. Goods can either be
 * defined directly by providing the full details of the goods, it can be
 * referenced by transport order id or an external reference to goods defined by
 * an external system.
 */
export interface Contents {
  /** Description of the contents. [optional] */
  description?: string;
  /** External orders contained in this shipment. */
  external_orders?: ExternalOrderContentItem[];
  /** Goods a.k.a. line items. */
  goods?: LineItem[];
  /** Transport orders contained in this shipment, so called consolidated shipment. */
  transport_orders?: TransportOrderContentItem[];
}

/** @default "UNKNOWN" */
export type ContentsType =
  | "UNKNOWN"
  | "DOCUMENTS"
  | "GIFT"
  | "COMMERCIAL_SAMPLE"
  | "SALE"
  | "RETURN"
  | "OTHER"
  | "DANGEROUS_GOODS"
  | "HUMANITARIAN_DONATIONS";

/** Geolocation coordinates */
export interface Coordinates {
  /**
   * Latitude
   * @format double
   */
  lat?: number;
  /**
   * Longitude
   * @format double
   */
  lng?: number;
}

/** For internal use [internal] */
export interface CountConsolidatedShipmentsRequest {
  /** List of filtering criteria to count consolidated shipments for */
  filters?: ConsolidatedShipmentsFiltering[];
}

/** For internal use [internal] */
export interface CountConsolidatedShipmentsResponse {
  /** List of count results, one for each filter in the request */
  results?: CountConsolidatedShipmentsResponseCountResult[];
}

export interface CountConsolidatedShipmentsResponseCountResult {
  /**
   * The count of consolidated shipments matching the filter
   * @format int64
   */
  count?: string;
  /** The filtering criteria that was applied */
  filter?: ConsolidatedShipmentsFiltering;
}

export interface CountPendingShipmentsRequest {
  filtering?: FilteringPendingShipments;
}

export interface CountPendingShipmentsResponse {
  /** @format uint64 */
  total_count?: number;
}

/** Request object that is used to create a Shipment from order. [deprecated] */
export interface CreateCompositeShipmentFromOrderRequest {
  /** List of addons. */
  addons?: Addon[];
  /**
   * Address where deliveries of this shipment should be returned to. [optional]
   * A default return address is taken from the sender address ("address_from") which is usually the address of the warehouse.
   */
  address_return?: Address;
  /** ID of the carrier contract to be used for booking. [optional] */
  carrier_contract_id?: string;
  /**
   * Contents of the shipment
   * Contents contains all goods sent in a Shipment or Parcel. Goods can either be
   * defined directly by providing the full details of the goods, it can be
   * referenced by transport order id or an external reference to goods defined by
   * an external system.
   */
  contents?: Contents;
  /** Optional instructions to the courier. */
  courier_instructions?: string;
  /** Must be fully specified in case customs declaration should be generated for shipment. */
  customs_declaration?: CustomsDeclaration;
  /** Time range when the deliveries will most likely be delivered to the customer. */
  delivery_time?: DateTimeRange;
  /**
   * Can be used to store a unique identifier from the merchant. For example
   * external order ID or external shipment ID.
   */
  external_id?: string;
  /**
   * Generic key-value object that can be used to attach additional
   * information to the shipment.
   */
  meta?: Record<string, string>;
  /**
   * Number of parcels to generate. If supplied it will override the number
   * of parcels created for this shipment. Otherwise the number of parcels
   * will default to one
   * @format uint64
   */
  number_of_parcels?: number;
  /** ParcelFreeText is a custom description to be assigned to all parcels in the shipment. */
  parcel_free_text?: string;
  /** The date that the shipment will most likely be dispatched from the warehouse. [required] */
  shipping_date?: string;
  /**
   * Specific shipping product ID by which the generated parcels should be delivered. If tos_id is provided and the
   * referenced order has field metadata.session.method, this field is optional. Otherwise, it is required.
   */
  shipping_method?: string;
  /** TosId is an order ID as given from TOS. [required] */
  tos_id?: string;
}

/** Request object that is used to create a Shipment from another source, for example via a COS session. */
export interface CreateCompositeShipmentFromRequest {
  /**
   * Address where deliveries of this shipment should be returned to. [optional]
   * A default return address is taken from the sender address ("address_from") which is usually the address of the warehouse.
   */
  address_return?: Address;
  /** ID of the carrier contract to be used for booking. [optional] */
  carrier_contract_id?: string;
  /** CosSessionId a session id as given from COS. [required] */
  cos_session_id?: string;
  /** Must be fully specified in case customs declaration should be generated for shipment. */
  customs_declaration?: CustomsDeclaration;
  /**
   * Number of parcels to generate. If supplied it will override the number
   * of parcels created for this shipment. Otherwise the number of parcels
   * will default to one.
   * @format uint64
   */
  number_of_parcels?: number;
  /**
   * ParcelFreeText is a custom description to be assigned to all parcels in the shipment.
   * Cannot be used together with parcels.free_text.
   */
  parcel_free_text?: string;
  /**
   * If the parcels element is provided the number_of_parcels field should be set to the length of the
   * parcels array or when number_of_parcel value is skipped the number_of_parcel will be calculated
   * based on parcels array length.
   */
  parcels?: ParcelDetails[];
  /** The date that the shipment will most likely be dispatched from the warehouse. [required] */
  shipping_date?: string;
}

/**
 * Request object that is used to create a Shipment together with Parcels
 * and Deliveries all at once.
 */
export interface CreateCompositeShipmentRequest {
  /** Addons that should be used for the shipment. */
  addons?: Addon[];
  /**
   * Address where the shipment will be dispatched from. Most often the
   * address of the warehouse. [required]
   * Common address entity that used almost everywhere in Ingrid's API.
   */
  address_from?: Address;
  /** ID of the warehouse, from which package will be delivered. */
  address_from_location_ref?: string;
  /**
   * Address where deliveries of this shipment should be returned to. [optional]
   * A default return address is taken from the sender address ("address_from") which is usually the address of the warehouse.
   */
  address_return?: Address;
  /**
   * Destination address. For example address of the service point or the click
   * and collect store. [required]
   * Common address entity that used almost everywhere in Ingrid's API.
   */
  address_to?: Address;
  /** ID of the carrier contract to be used for booking. [optional] */
  carrier_contract_id?: string;
  /** [optional] Info on the Consolidated shipment that this shipment is part of. */
  consolidated_shipment?: ConsolidatedShipmentDetails;
  /**
   * Contents of shipment. Can be of different types - goods, transport orders and external orders.
   * Either contents has to be provided on the shipment or on each parcel, but not both.
   */
  contents?: Contents;
  /** Optional instructions to the courier */
  courier_instructions?: string;
  /**
   * Contains the customer information such as name, email, phone and address. This field can be omitted, only if tos_id
   * is not empty and the referenced order has enough data to derive customer info from it.
   */
  customer_info?: CustomerInfo;
  /** Must be fully specified in case customs declaration should be generated for shipment. */
  customs_declaration?: CustomsDeclaration;
  /** Time range when the deliveries will most likely be delivered to the customer. */
  delivery_time?: DateTimeRange;
  /** Dimensions will override the dimensions for each created parcel. Unit is millimeters (mm) [deprecated]. */
  dimensions?: Dimensions;
  /**
   * DirectionType informs about initial shipment direction. [optional]
   * Indicates intended direction of parcel, shipment etc.
   *
   *  - OUTBOUND: From merchant to customer.
   *  - RETURN: Return from customer to merchant.
   *  - UNSPECIFIED: Unspecified means we do not know the direction. It is the default state when we do not know any better.
   */
  direction_type?: DirectionType;
  /**
   * Can be used to store a unique identifier from the merchant. For example
   * external order ID or external shipment ID.
   */
  external_id?: string;
  /** Use `contents` instead [deprecated] */
  line_items?: LineItem[];
  /** ID of the pickup location where the parcels should be delivered to. */
  location_ref?: string;
  /**
   * Indicates the kind of pickup location [optional]
   * - UNKNOWN_PICKUP_LOCATION_TYPE: Location type is not known for some reason
   *  - LOCKER: Locker location type. Example Instabox or a DHL locker
   *  - STORE: Can be a merchant's store or any other store that handles logistics
   *  - POSTOFFICE: Postal office
   *  - MANNED: A manned service point
   */
  location_type?: PickupLocationType;
  /**
   * Generic key-value object that can be used to attach additional
   * information to the shipment.
   */
  meta?: Record<string, string>;
  /**
   * Number of parcels to generate if parcel details is not provided. Defaults to 1 if not set. If
   * parcel details is used then this should not be set.
   * @format uint64
   */
  number_of_parcels?: number;
  /** ID of the OUTBOUND shipment (delivered from merchant to customer). Must be used only for the return shipment creation (with direction_type = "RETURN"). [optional] */
  outbound_shipment_id?: string;
  /**
   * Custom description (notes) that will be assigned to all parcels in the shipment.
   * Cannot be used together with parcels.free_text.
   */
  parcel_free_text?: string;
  /**
   * If provided, the number_of_parcels field should be set to the length of the parcels array or
   * if number_of_parcel is not set it will be calculated based on parcels array length.
   */
  parcels?: ParcelDetails[];
  /** ID of the pending shipment that this shipment is based on. */
  pending_shipment_id?: string;
  /**
   * Total value of the shipment including tax. Example 10000 is 100 SEK.
   * @format uint64
   */
  shipment_value?: number;
  /** ID of shipping category that user choice belongs to. It's used to resolve virtual methods connected with ship. category. */
  shipping_category_ref?: string;
  /** The date that the shipment will most likely be dispatched from the warehouse. [required] */
  shipping_date?: string;
  /** Specific shipping product ID by which the generated parcels should be delivered. [required] */
  shipping_method?: string;
  /**
   * Order ID from TOS. [optional] If provided, shipment details from the TOS will be used to
   * populate fields not set in the request. Fields provided in the request will override fields
   * from the TOS.
   */
  tos_id?: string;
  /** [optional]  Defines who is billed for freight/transport charges. */
  transport_payer?: Payer;
  /**
   * Weight in grams (g). If using parcels instead of number_of_parcels, prefer to set weight
   * individually on each parcel. If not set, the weight will be calculated as the sum of the
   * weights of the Contents.Goods (if available).
   * @format uint64
   */
  weight?: number;
}

/** Response from the shipment create call. Contains the latest shipment state. */
export interface CreateCompositeShipmentResponse {
  /**
   * Current shipment object state
   * Shipment is the top level object in SOM. A shipment can be composed of
   * multiple parcels and each parcel can contain many deliveries. Only one
   * delivery can be active at a time.
   */
  shipment?: Shipment;
}

export interface CustomBookingMethod {
  addresses?: CustomBookingMethodAddresses;
  booking_method?: string;
  /** Carrier full name. */
  carrier?: string;
  id?: string;
  method?: string;
  /** Name of the shipping product. */
  name?: string;
  return_booking?: CustomBookingMethodReturnBooking;
  status?: BookingMethodStatus;
  steps?: CustomBookingMethodStep[];
}

export interface CustomBookingMethodAddresses {
  /** Common address entity that used almost everywhere in Ingrid's API. */
  return?: Address;
}

export interface CustomBookingMethodReturnBooking {
  label_consolidation?: boolean;
  method?: string;
  use_address_from_as_return?: boolean;
}

export interface CustomBookingMethodStep {
  actions?: StepExpression[];
  filters?: StepExpression[];
  name?: string;
}

export interface CustomBookingMethodTestRunLog {
  custom_booking_methods?: Record<string, CustomBookingMethod>;
  steps?: StepLog[];
}

export interface CustomBookingsMethodTestRun {
  /** Errors produced during preparation of the shipment, or during the CBM engine execution. */
  errors?: string;
  /**
   * Request object that is used to create a Shipment together with Parcels
   * and Deliveries all at once.
   */
  input_shipment?: CreateCompositeShipmentRequest;
  /**
   * Request object that is used to create a Shipment together with Parcels
   * and Deliveries all at once.
   */
  output_shipment?: CreateCompositeShipmentRequest;
  run_logs?: CustomBookingMethodTestRunLog;
}

/** Contains the necessary information about a customer in order to make a delivery */
export interface CustomerInfo {
  /** Customer's home address. */
  address?: Address;
  /** Customer's email. */
  email?: string;
  /** Customer's national identification number, eg. SSN. */
  national_identification_number?: string;
  /** Customer's mobile phone number. */
  phone?: string;
}

export interface Customs {
  /** Customs declaration provided in request. */
  declaration?: CustomsDeclaration;
  /** Customs declaration document available after booking the parcel with customs declaration request. */
  document?: CustomsDeclarationDocument;
}

export interface CustomsDeclaration {
  /**
   * Use GeneralCustomsDeclaration instead. [deprecated]
   * Deprecated, use GeneralCustomsDeclaration
   */
  cn22?: DeclarationCN;
  /**
   * Use GeneralCustomsDeclaration instead. [deprecated]
   * Deprecated, use GeneralCustomsDeclaration
   */
  cn23?: DeclarationCN;
  /**
   * Use GeneralCustomsDeclaration instead. [deprecated]
   * Deprecated, use GeneralCustomsDeclaration
   */
  cp72?: DeclarationCN;
  /**
   * Use GeneralCustomsDeclaration instead. [deprecated]
   * Deprecated, use GeneralCustomsDeclaration
   */
  electronic_invoice_fedex?: ElectronicInvoiceFedex;
  /**
   * Use GeneralCustomsDeclaration instead. [deprecated]
   * Deprecated, use GeneralCustomsDeclaration
   */
  electronic_invoice_lotte?: ElectronicInvoiceLotte;
  /**
   * Use GeneralCustomsDeclaration instead. [deprecated]
   * Deprecated, use GeneralCustomsDeclaration
   */
  electronic_invoice_ups?: ElectronicInvoiceUPS;
  general_customs_declaration?: GeneralCustomsDeclaration;
}

export interface CustomsDeclarationDocument {
  /** File format (ex. "pdf", "png"). */
  format?: string;
  type?: CustomsDeclarationDocumentType;
  /** The url where the declaration label is located. */
  url?: string;
}

/** @default "TYPE_UNKNOWN" */
export type CustomsDeclarationDocumentType =
  | "TYPE_UNKNOWN"
  | "TYPE_CN22"
  | "TYPE_CN23"
  | "TYPE_CP72"
  | "TYPE_ELECTRONIC_INVOICE_UPS"
  | "TYPE_ELECTRONIC_INVOICE_LOTTE"
  | "TYPE_ELECTRONIC_INVOICE_FEDEX"
  | "TYPE_ELECTRONIC_INVOICE";

/** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
export interface DateTimeRange {
  /** End of the interval. Date is returned in RFC3339 format. Example `2018-09-08T22:47:31Z`. */
  end?: string;
  /** Start of the interval. Date is returned in RFC3339 format. Example `2018-09-08T22:47:31Z` */
  start?: string;
}

export interface DeclarationCN {
  /** Contents explanation - short general description. */
  contents_explanation?: string;
  /** Content type of goods inside the parcel. For example - Sale, Gift etc. See ContentsType reference for details */
  contents_type?: ContentsType;
  /** Purchase currency. */
  currency?: string;
  /** EORI number for imports/exports from UK */
  eori_number?: string;
  /** List of items packed inside parcel. */
  items?: DeclarationCNItem[];
  /**
   * Total gross weight is parcel weight in grams (including packaging).
   * @format int64
   */
  total_gross_weight?: number;
}

export interface DeclarationCNItem {
  /** Country of origin - country were this item were produced. */
  country_of_origin?: string;
  /** General description of this item. */
  description?: string;
  /** Harmonized System tariff number. */
  hs_tariff_number?: string;
  /**
   * Quantity of this item.
   * @format int64
   */
  quantity?: number;
  /**
   * Total net weight of the item in grams (for the whole quantity).
   * @format int64
   */
  total_net_weight?: number;
  /**
   * Total value of this item (for the whole quantity).
   * Only integer values are supported and because of that provided value should always be in smallest currency unit possible (fractional monetary unit)
   * For example, 25.99 USD should be converted to 2599
   * @format int64
   */
  total_value?: number;
}

export interface DeleteDraftCustomBookingMethodRequest {
  id?: string;
}

/**
 * Delivery is the parcel with start and end destination. A delivery always
 * has one parcel that it belongs to.
 */
export interface Delivery {
  /** Addons available for the shipment. */
  addons?: Addon[];
  /** Origin address for this delivery. */
  address_from?: Address;
  /** The return address to which a delivery that is returned should be sent. */
  address_return?: Address;
  /** Destination address for this delivery. */
  address_to?: Address;
  /**
   * CarrierShipmentId is the internal identifier assigned by the carrier to the booked shipment or consignment.
   * Unlike the shipment_tracking_number, this value is used for system-to-system communication, support, or referencing
   * the shipment in carrier APIs. It is not visible to the end customer.
   */
  carrier_shipment_id?: string;
  /** Optional instructions to the courier. */
  courier_instructions?: string;
  /** Timestamp when delivery was created. */
  created_at?: string;
  /** State of the delivery. Possible values are 'created','booked','pickup'. */
  delivery_status?: string;
  /**
   * Time range when the deliveries will most likely be delivered to the customer. When time is set
   * to 00:00 it means Ingrid has presented a set of days or business days e.g. 2-3 Business days.
   */
  delivery_time?: DateTimeRange;
  /** Documents associated with the delivery. */
  documents?: Documents;
  /** Additional reference set by carrier which can be used to identify and search delivery. */
  external_ref?: string;
  /** Unique id of the delivery (uuid). */
  id?: string;
  /** Use documents.label_url instead. [deprecated] */
  label_url?: string;
  /** ID of the service point location if applicable. */
  location_ref?: string;
  /**
   * Indicates the kind of pickup location
   * - UNKNOWN_PICKUP_LOCATION_TYPE: Location type is not known for some reason
   *  - LOCKER: Locker location type. Example Instabox or a DHL locker
   *  - STORE: Can be a merchant's store or any other store that handles logistics
   *  - POSTOFFICE: Postal office
   *  - MANNED: A manned service point
   */
  location_type?: PickupLocationType;
  /** ID of the parcel which the delivery belongs to. */
  parcel_id?: string;
  /** Name of a Custom Shipping method used during booking. */
  requested_shipping_method?: string;
  /**
   * ReturnCode is a code that the end user is supposed to write on the physical package. Used instead of
   * a label or QR code, if available.
   */
  return_code?: string;
  /** Use documents.return_label_url instead. [deprecated] */
  return_label_url?: string;
  /** Shipping product ID for the return delivery. */
  return_shipping_method?: string;
  /** Tracking number for the return delivery. */
  return_tracking_number?: string;
  /** Tracking URL for return delivery if available */
  return_tracking_url?: string;
  /** Consolidated tracking number for all deliveries in a shipment. */
  shipment_tracking_number?: string;
  /** Shipping product ID for the delivery. */
  shipping_method?: string;
  /** Tracking number for the delivery. */
  tracking_number?: string;
  /** Tracking URL for the upcoming delivery if available. */
  tracking_url?: string;
  /** Transit time [deprecated]. */
  transit_time?: TransitTime;
  /** Timestamp when delivery was last updated. */
  updated_at?: string;
  /**
   * Weight of the delivery in grams.
   * @format uint64
   */
  weight?: number;
}

/** Length, height and width in millimeters. */
export interface Dimensions {
  /**
   * Height in millimeters. For example `50` is 0,05 m
   * @format uint64
   */
  height?: number;
  /**
   * Length in millimeters. For example `140` is 0,14 m
   * @format uint64
   */
  length?: number;
  /**
   * Width in millimeters. For example `20` is 2 cm
   * @format uint64
   */
  width?: number;
}

/**
 * Indicates intended direction of parcel, shipment etc.
 *
 *  - OUTBOUND: From merchant to customer.
 *  - RETURN: Return from customer to merchant.
 *  - UNSPECIFIED: Unspecified means we do not know the direction. It is the default state when we do not know any better.
 * @default "UNKNOWN_DIRECTION_TYPE"
 */
export type DirectionType = "UNKNOWN_DIRECTION_TYPE" | "OUTBOUND" | "RETURN" | "UNSPECIFIED";

export interface Documents {
  /** URL of the delivery's shipping label. */
  label_url?: string;
  /** QR code URL that can be used instead of the shipping label. */
  qr_code_url?: string;
  /** URL of the delivery's return label. */
  return_label_url?: string;
  /** QR code URL that can be used instead of the return shipping label. */
  return_qr_code_url?: string;
}

export interface ElectronicInvoiceFedex {
  /** Content type of goods inside the parcel. For example - Sale, Gift etc. See ContentsType reference for details */
  contents_type?: ContentsType;
  /** Purchase currency */
  currency?: string;
  /** Statement that provides the legal explanation that customs uses to process your shipment. Needs to meet certain country's law restrictions. */
  declaration_statement?: string;
  /** International Commercial Terms. */
  incoterms?: InCoTerms;
  /** List of items packed in the parcel */
  items?: ElectronicInvoiceFedexItem[];
}

export interface ElectronicInvoiceFedexItem {
  /** Country where this item was produced */
  country_of_origin?: string;
  /** General description of this item */
  description?: string;
  /** Harmonized System tariff number */
  hs_tariff_number?: string;
  /**
   * Quantity of this item
   * @format int64
   */
  quantity?: number;
  /** Quantity units of this item */
  quantity_units?: string;
  /**
   * Total net weight of this item in grams (for the whole quantity)
   * @format int64
   */
  total_net_weight?: number;
  /**
   * Total value of this item (for the whole quantity)
   * Only integer values are supported and because of that provided value should always be in smallest currency unit possible (fractional monetary unit)
   * For example, 25.99 USD should be converted to 2599
   * @format int64
   */
  total_value?: number;
  /**
   * Value per unit of quantity
   * Only integer values are supported and because of that provided value should always be in smallest currency unit possible (fractional monetary unit)
   * For example, 25.99 USD should be converted to 2599
   * @format int64
   */
  unit_value?: number;
}

export interface ElectronicInvoiceLotte {
  /** Buyer's personal customs clearance number/id. */
  buyer_personal_customs_clearance_number?: string;
  /** Purchase currency. */
  currency?: string;
  /** Date when the invoice was issued */
  invoice_date?: string;
  /** Unique number that identifies the invoice */
  invoice_number?: string;
  /** List of items packed inside parcel. */
  items?: ElectronicInvoiceLotteItem[];
  /** Seller's Customs Authorization Number. Required for orders above 6000 EUR. */
  seller_customs_authorization_number?: string;
  /** SoldTo is the address of the person who paid for the purchase. */
  sold_to?: Address;
}

export interface ElectronicInvoiceLotteItem {
  /** Brand of the item */
  brand?: string;
  /** Country of origin - country were this item were produced. */
  country_of_origin?: string;
  /** General description of this item. */
  description?: string;
  /** Harmonized System tariff number. */
  hs_tariff_number?: string;
  /**
   * Quantity of this item.
   * @format int64
   */
  quantity?: number;
  /**
   * Total value of this item (for the whole quantity).
   * Only integer values are supported and because of that provided value should always be in smallest currency unit possible (fractional monetary unit)
   * For example, 25.99 USD should be converted to 2599
   * @format int64
   */
  total_value?: number;
}

export interface ElectronicInvoiceUPS {
  /** Contents explanation - short general description. */
  contents_explanation?: string;
  /** Content type of goods inside the parcel. For example - Sale, Gift etc. See ContentsType reference for details */
  contents_type?: ContentsType;
  /** Purchase currency. */
  currency?: string;
  /** Date when the invoice was issued */
  invoice_date?: string;
  /** Unique number that identifies the invoice */
  invoice_number?: string;
  /** List of items packed inside parcel. */
  items?: ElectronicInvoiceUPSItem[];
  /** SoldTo is the address of the person who paid for the purchase. */
  sold_to?: Address;
  /**
   * Total gross weight is parcel weight in grams (including packaging).
   * @format int64
   */
  total_gross_weight?: number;
}

export interface ElectronicInvoiceUPSItem {
  /** Country of origin - country were this item were produced. */
  country_of_origin?: string;
  /** General description of this item. */
  description?: string;
  /** Harmonized System tariff number. */
  hs_tariff_number?: string;
  /**
   * Quantity of this item.
   * @format int64
   */
  quantity?: number;
  /**
   * Total value of this item (for the whole quantity).
   * Only integer values are supported and because of that provided value should always be in smallest currency unit possible (fractional monetary unit)
   * For example, 25.99 USD should be converted to 2599
   * @format int64
   */
  total_value?: number;
}

/** Reference to goods defined by an external system. */
export interface ExternalOrderContentItem {
  /** A reference to an external (merchant) order. */
  external_id?: string;
}

export interface FetchPickupLocationsRequest {
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address_from?: Address;
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address_to?: Address;
  location_type_filters?: PickupLocationType[];
  /** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
  pickup_time?: DateTimeRange;
  shipping_method?: string;
}

export interface FetchPickupLocationsResponse {
  pickup_locations?: PickupLocation[];
}

/** Filter for matching a count between max and min. */
export interface FilterCountRange {
  /** @format int64 */
  max?: string;
  /** @format int64 */
  min?: string;
}

/** Filters for listing shipments. */
export interface Filtering {
  /** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
  created_at_range?: DateTimeRange;
  /** Id will be matched against shipment_id, tos_id and external_id. */
  id?: string;
  /**
   * [deprecated]
   * Filter for matching a count between max and min.
   */
  line_items?: FilterCountRange;
  shipment_ids?: string[];
  /** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
  shipping_date_range?: DateTimeRange;
  shipping_methods?: string[];
  statuses?: string[];
  tos_ids?: string[];
}

export interface FilteringPendingShipments {
  /** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
  created_at_range?: DateTimeRange;
  /**
   * Id will be matched against:
   * pending_shipment_id, tos_id and external_id
   */
  id?: string;
}

export interface GeneralCustomsDeclaration {
  /** Contact info of a buyer. */
  buyer_contact?: GeneralCustomsDeclarationContactInfo;
  /** A unique identification numbers of a buyer, for instance, EORI, VOEC. */
  buyer_identification_numbers?: TaxIdentificationNumbers;
  /**
   * A unique VAT tax identification number of a buyer / importer.
   * Deprecated: use `buyer_identification_numbers` instead.
   */
  buyer_tax_id_number?: string;
  /** Contents explanation - short general description. */
  contents_explanation?: string;
  /** Content type of goods inside the parcel. For example - Sale, Gift etc. See ContentsType reference for details. */
  contents_type?: ContentsType;
  /** Purchase currency. */
  currency?: string;
  /** Statement that provides the legal explanation that customs uses to process your shipment. Needs to meet certain country's law restrictions. */
  declaration_statement?: string;
  /** Billing for import duties and taxes, controls who is billed */
  duties_payer?: Payer;
  /** Information about the importer of record, if other party than the sold_to is used. */
  importer_of_record?: GeneralCustomsDeclarationImporterOfRecord;
  /** International Commercial Terms. */
  incoterms?: InCoTerms;
  /** The date when the invoice was issued. */
  invoice_date?: string;
  /** A unique number that identifies the invoice. */
  invoice_number?: string;
  /** List of items packed inside the parcel. */
  items?: GeneralCustomsDeclarationItem[];
  /** Name of port of departure, shipment or destination as required under the applicable delivery term. */
  place_of_incoterms?: string;
  /** The address of a seller / exporter. */
  seller_address?: Address;
  /** Contact info of a seller / exporter */
  seller_contact?: GeneralCustomsDeclarationContactInfo;
  /** A unique identification numbers of a seller / exporter, for instance, EORI, VOEC. */
  seller_identification_numbers?: TaxIdentificationNumbers;
  /**
   * A unique VAT tax identification number of a seller / exporter.
   * Deprecated: use `seller_identification_numbers` instead.
   */
  seller_tax_id_number?: string;
  /** The address of a buyer. */
  sold_to?: Address;
  /** Additional Instructions provided in the customs. */
  special_instructions?: string;
  /**
   * Total gross weight of the parcel in grams (including packaging).
   * @format int64
   */
  total_gross_weight?: number;
}

export interface GeneralCustomsDeclarationContactInfo {
  email?: string;
  phone?: string;
}

export interface GeneralCustomsDeclarationImporterOfRecord {
  /** Optional account number associated with the importer for customs/brokerage context. */
  account_number?: string;
  /** Importer address, usually in the import country. */
  address?: Address;
  /** Contact used by customs/broker for queries. */
  contact?: GeneralCustomsDeclarationContactInfo;
  /** A unique identification numbers of a importer, for instance, EORI, VOEC. */
  identification_numbers?: TaxIdentificationNumbers;
}

export interface GeneralCustomsDeclarationItem {
  /** Allows for providing one or more lines of additional information as needed such as manufacturer address info. [optional] */
  additional_information?: string[];
  /** Item's brand. */
  brand?: string;
  /** Item's commodity category, for example, babies products. */
  category?: string;
  /** Country of origin - country were this item were produced. */
  country_of_origin?: string;
  /** Used to describe items such as composition. For example, 50 percent wool and 50 percent leather. [optional] */
  description?: string;
  /** Harmonized System tariff number. */
  hs_tariff_number?: string;
  /** Name of this item. */
  name?: string;
  /**
   * Quantity of this item.
   * @format int64
   */
  quantity?: number;
  /** Item references can be used to communicate order numbers, make, models, dangerous goods content identifiers, registration numbers and more. [optional] */
  references?: ItemReference[];
  /** SKU of this item. */
  sku?: string;
  /**
   * Used only for special case scenarios when unit_value should not be used
   * such as when custom declarations should be using a transfer price for eg. US exports
   * @format int64
   */
  unit_alternative_value?: number;
  /**
   * Gross weight of the item in grams (including packaging), without taking quantity into account.
   * @format int64
   */
  unit_gross_weight?: number;
  /**
   * Net weight of the item in grams, without taking quantity into account.
   * @format int64
   */
  unit_net_weight?: number;
  /**
   * Value of the single item, without taking quantity into account.
   * Only integer values are supported and because of that provided value should always be in smallest currency unit possible (fractional monetary unit).
   * For example, 25.99 USD should be converted to 2599.
   * @format int64
   */
  unit_value?: number;
}

export interface GetConsolidatedShipmentResponse {
  consolidated_shipment?: ConsolidatedShipment;
  /** only returned if expand=SHIPMENTS_SUMMARY, expand=SHIPMENTS_WITH_PARCELS, expand=SHIPMENTS_WITH_LINE_ITEMS or expand=SHIPMENTS_FULL is used */
  shipments?: Shipment[];
}

export interface GetCustomBookingMethodResponse {
  custom_booking_method?: CustomBookingMethod;
}

/** Returns a delivery object */
export interface GetDeliveryResponse {
  /**
   * Delivery object state
   * Delivery is the parcel with start and end destination. A delivery always
   * has one parcel that it belongs to.
   */
  delivery?: Delivery;
}

/** Returns a Pending Shipment */
export interface GetPendingShipmentResponse {
  /** Pending Shipment result object */
  pending_shipment?: PendingShipment;
}

export interface GetRecordResponse {
  /** Represents a delivery that is or has to be booked. */
  record?: BookingRecord;
}

/** Returns latest shipment state. */
export interface GetShipmentResponse {
  /**
   * Current shipment object state
   * Shipment is the top level object in SOM. A shipment can be composed of
   * multiple parcels and each parcel can contain many deliveries. Only one
   * delivery can be active at a time.
   */
  shipment?: Shipment;
}

export interface HydrateShipmentResponse {
  /**
   * Request object that is used to create a Shipment together with Parcels
   * and Deliveries all at once.
   */
  shipment?: CreateCompositeShipmentRequest;
}

/**
 * International Commercial Terms.
 *
 *  - EXW: Ex Works.
 *  - FCA: Free Carrier.
 *  - FAS: Free Alongside Ship.
 *  - FOB: Free On Board.
 *  - CFR: Cost And Freight.
 *  - CIF: Cost, Insurance and Freight.
 *  - CPT: Carriage Paid To.
 *  - CIP: Carriage Insurance Paid To.
 *  - DAT: Delivered At Terminal.
 *  - DAP: Delivered At Place.
 *  - DDP: Delivered Duty Paid.
 *  - DAF: Delivered At Frontier.
 *  - DDU: Delivery Duty Unpaid.
 *  - DEQ: Delivered Ex Quay.
 *  - DES: Delivered Ex Ship.
 *  - DPU: Delivered at Place Unloaded.
 * @default "INCOTERMS_UNKNOWN"
 */
export type InCoTerms =
  | "INCOTERMS_UNKNOWN"
  | "EXW"
  | "FCA"
  | "FAS"
  | "FOB"
  | "CFR"
  | "CIF"
  | "CPT"
  | "CIP"
  | "DAT"
  | "DAP"
  | "DDP"
  | "DAF"
  | "DDU"
  | "DEQ"
  | "DES"
  | "DPU";

export interface ItemReference {
  /** The code corresponds to the type. Following the example of using MID as type the MID code should be specified here as a value. */
  code?: string;
  /** The type of code needs to be specified. For example "MID" (Manufacturers Identification Code) can be specified as the type. */
  type?: string;
}

/**
 * Physical item of the parcel. A parcel can contain many line
 * items. The parameters on the line item are used by the shipping rules
 * framework to make better shipping decisions.
 */
export interface LineItem {
  /** Currency of the line item. [optional] */
  currency?: string;
  /** Description of the product [optional] */
  description?: string;
  /**
   * Dimensions of the line item. [optional]
   * Length, height and width in millimeters.
   */
  dimensions?: Dimensions;
  /** Harmonized System tariff number. */
  hs_tariff_number?: string;
  /** Product name or title [required] */
  name?: string;
  /**
   * Price of the line item. [optional]
   * @format uint64
   */
  price?: number;
  /**
   * Number of items. [required]
   * @format uint64
   */
  quantity?: number;
  /** Unique product identifier. [required] */
  sku?: string;
  /** List of tags or attributes that can be attached to this line item. */
  tags?: string[];
  /**
   * Weight of the line item in grams. For example `200` is 0,2 kg.
   * @format uint64
   */
  weight?: number;
}

/** For internal use [internal] */
export interface ListConsolidatedShipmentsRequest {
  filtering?: ConsolidatedShipmentsFiltering;
  order_by_direction?: ListConsolidatedShipmentsRequestOrderDirection;
  /** Pagination filter. */
  pagination?: Pagination;
}

/** @default "DESCENDING" */
export type ListConsolidatedShipmentsRequestOrderDirection = "DESCENDING" | "ASCENDING";

/** For internal use [internal] */
export interface ListConsolidatedShipmentsResponse {
  /** List of shipments belonging to an order. */
  consolidated_shipments?: ConsolidatedShipment[];
  /** @format uint64 */
  count?: number;
  more_shipments?: boolean;
}

export interface ListCustomBookingMethodsRequest {
  filtering?: ListCustomBookingMethodsRequestFiltering;
  order_by_direction?: OrderDirection;
  /** Pagination filter. */
  pagination?: Pagination;
}

export interface ListCustomBookingMethodsRequestFiltering {
  booking_methods?: string[];
  /** Id will be matched against Published and Draft custom booking methods. */
  id?: string;
  include_statuses?: BookingMethodStatus[];
  methods?: string[];
  name?: string[];
}

export interface ListCustomBookingMethodsResponse {
  custom_booking_methods?: CustomBookingMethod[];
}

export interface ListPendingShipmentsRequest {
  filtering?: FilteringPendingShipments;
  order_by_direction?: OrderDirection;
  /** Pagination filter. */
  pagination?: Pagination;
}

export interface ListPendingShipmentsResponse {
  pending_shipments?: PendingShipment[];
}

/** Request for listing shipments matching filter. */
export interface ListShipmentsRequest {
  /** Shipments matching all the filters will be returned. */
  filtering?: Filtering;
  order_by_direction?: ListShipmentsRequestOrderDirection;
  /** Max page size is 1000, if set higher, it will be capped to 1000. */
  pagination?: Pagination;
  /** Order ID, deprecated use filtering.tos_ids instead [deprecated]. */
  tos_id?: string;
}

/** @default "DESCENDING" */
export type ListShipmentsRequestOrderDirection = "DESCENDING" | "ASCENDING";

/**
 * Response for a list shipment request. Contains the shipments matching the request filters and
 * information about if there are more pages.
 */
export interface ListShipmentsResponse {
  /**
   * The total number of shipments that match the filtering criteria (or 5000 if more than 5000 shipments match).
   * @format uint64
   */
  count?: number;
  more_shipments?: boolean;
  /** List of shipments matching the filtering criteria. */
  shipments?: Shipment[];
}

export interface OpenConsolidatedShipmentRequest {
  /** [optional] ID of the carrier contract to be used for booking. */
  carrier_contract_id?: string;
  /** Holds information about customs declaration for the consolidated shipment. */
  customs_declaration?: CustomsDeclaration;
  /** [optional] External ID of the shipment. Can be used to store a unique identifier from the merchant. */
  external_id?: string;
  /** [required] Address where the shipment will be dispatched from. Most often the address of the warehouse. */
  from?: Party;
  /** [optional] Shipment metadata tags */
  meta?: Record<string, string>;
  /** [optional] Pallets included in the shipment. The length of the array corresponds to the number of pallets. Must include at least one pallet. if omitted then one applet will be assumed */
  pallets?: Pallet[];
  /** [required] Date when the shipment will most likely be dispatched from the warehouse. RFC-3339 format. */
  shipping_date?: string;
  /** [required] Shipping method for the Consolidated Shipment */
  shipping_method?: string;
  /** [required] Destination address. For example address of the distribution center of the carrier. */
  to?: Party;
}

export interface OpenConsolidatedShipmentResponse {
  consolidated_shipment?: ConsolidatedShipment;
}

/** @default "DESCENDING" */
export type OrderDirection = "DESCENDING" | "ASCENDING";

/** Pagination filter. */
export interface Pagination {
  /** @format uint64 */
  limit?: number;
  /** @format uint64 */
  offset?: number;
}

export interface Pallet {
  /** [output] Timestamp when pallet was created. RFC-3339 format. */
  created_at?: string;
  /** [optional] Dimensions of the pallet. If provided, this value will be sent to carrier. */
  dimensions?: Dimensions;
  /** [optional] External ID of the pallet. Can be used to store a unique identifier from the merchant. */
  external_id?: string;
  /** [output] ID of the pallet (uuid). */
  id?: string;
  /** [output] URL of the pallet's shipping label. */
  label_url?: string;
  /** [optional] Shipping methods on the pallet. If provided, this value will be sent to carrier. Required for some carriers. */
  shipping_methods?: string[];
  /** [output] Tracking number for the pallet. */
  tracking_number?: string;
  /** [output] URL of the pallet's tracking number. */
  tracking_url?: string;
  /** [output] Timestamp when pallet was updated. RFC-3339 format. */
  updated_at?: string;
  /**
   * [optional] Weight of the pallet in grams. If provided, this value will be sent to carrier. If omitted (or zero),
   * the weight will be summed by the weights of the shipments in the pallet.
   * @format uint64
   */
  weight?: number;
}

/**
 * Parcel is the physical package. One parcel can have at least one delivery
 * at a time.
 */
export interface Parcel {
  /** Contents of the parcel. */
  contents?: Contents;
  /** Timestamp when parcel was created. */
  created_at?: string;
  /** Deliveries associated with the parcel. */
  deliveries?: Delivery[];
  /** Length, height and width [optional]. */
  dimensions?: Dimensions;
  /** Custom description (notes) of a parcel. */
  free_text?: string;
  /** Unique ID of the parcel (uuid). */
  id?: string;
  /** Custom information about parcel visible on a label. */
  label_free_text?: string;
  /** Use `contents` instead [deprecated] */
  line_items?: LineItem[];
  /**
   * Index number of the individual parcel in a shipment, i.e parcel 3 of 5. [deprecated]
   * @format int64
   */
  parcel_number?: number;
  /**
   * Not used [deprecated].
   * @format int64
   */
  parcel_total?: number;
  /** ID of the shipment that parcel belongs to (uuid). */
  shipment_id?: string;
  /** Timestamp when parcel was last updated. */
  updated_at?: string;
  /**
   * Total weight of the parcel in grams.
   * @format uint64
   */
  weight?: number;
}

/**
 * ParcelDetails contains additional information about parcels. Represents the non-output-only
 * subset of Shipment Parcels.
 */
export interface ParcelDetails {
  /**
   * Parcel contents
   * Contents contains all goods sent in a Shipment or Parcel. Goods can either be
   * defined directly by providing the full details of the goods, it can be
   * referenced by transport order id or an external reference to goods defined by
   * an external system.
   */
  contents?: Contents;
  /**
   * Parcel dimensions
   * Length, height and width in millimeters.
   */
  dimensions?: Dimensions;
  /** Custom description (notes) of a parcel. */
  free_text?: string;
  label_free_text?: string;
  /**
   * Weight in grams
   * @format uint64
   */
  weight?: number;
}

export interface Party {
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address?: Address;
  email?: string;
  phone?: string;
}

export interface Payer {
  /** Optional carrier account used to settle this charge (if supported by the carrier). */
  account?: string;
  /** Required when type is THIRD_PARTY. */
  address?: Address;
  /**
   * Specifies who is billed for this specific charge (transport or duties) relative to shipment parties.
   * This does NOT describe the legal role in customs; it only indicates who pays this charge.
   */
  type?: PayerPayerType;
}

/**
 *  - PAYER_TYPE_UNSPECIFIED: Unspecified payer.
 *  - SENDER: Sender/shipper pays the charge.
 *  - RECIPIENT: Recipient/consignee pays the charge.
 *  - THIRD_PARTY: Third-party pays the charge.
 * @default "PAYER_TYPE_UNSPECIFIED"
 */
export type PayerPayerType = "PAYER_TYPE_UNSPECIFIED" | "SENDER" | "RECIPIENT" | "THIRD_PARTY";

/**
 * Pending shipment that has generated an error in the creation process and
 * therefore is in an invalid state and needs modifying.
 * This is an opt in feature for merchants
 */
export interface PendingShipment {
  /** Timestamp when shipment was received. */
  created_at?: string;
  /** Timestamp of when the pending shipment be deleted. */
  expires_at?: string;
  /** ID of the shipment (uuid). */
  id?: string;
  /**
   * Lookup ID of the shipment. This is a shorter version of the id that can be used to reference
   * the shipment.
   */
  lookup_id?: string;
  /** Shipment request that caused the error. Includes the errornous part of the request. */
  payload?: string;
  /** Error message recieved during create (and/or) booking of shipment. */
  raw_error_message?: string;
}

export interface PickupDistances {
  /** @format int64 */
  drive_distance?: number;
  /** @format int64 */
  drive_time?: number;
  /** @format int64 */
  walk_distance?: number;
  /** @format int64 */
  walk_time?: number;
}

export interface PickupLocation {
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address?: Address;
  distances?: PickupDistances;
  location_ref?: string;
  /**
   * - UNKNOWN_PICKUP_LOCATION_TYPE: Location type is not known for some reason
   *  - LOCKER: Locker location type. Example Instabox or a DHL locker
   *  - STORE: Can be a merchant's store or any other store that handles logistics
   *  - POSTOFFICE: Postal office
   *  - MANNED: A manned service point
   */
  location_type?: PickupLocationType;
  meta?: Record<string, string>;
  name?: string;
  shipping_method?: string;
}

/**
 * Indicates the kind of pickup location
 * - UNKNOWN_PICKUP_LOCATION_TYPE: Location type is not known for some reason
 *  - LOCKER: Locker location type. Example Instabox or a DHL locker
 *  - STORE: Can be a merchant's store or any other store that handles logistics
 *  - POSTOFFICE: Postal office
 *  - MANNED: A manned service point
 * @default "UNKNOWN_PICKUP_LOCATION_TYPE"
 */
export type PickupLocationType = "UNKNOWN_PICKUP_LOCATION_TYPE" | "LOCKER" | "STORE" | "POSTOFFICE" | "MANNED";

export interface Prompt {
  message?: string;
  role?: PromptRole;
  /** Timestamp of the prompt in RFC-3339 format. */
  timestamp?: string;
}

/** @default "USER" */
export type PromptRole = "USER" | "ASSISTANT";

export interface PublishCustomBookingMethodsRequest {
  custom_booking_methods?: CustomBookingMethod[];
}

export interface SaveDraftCustomBookingMethodsRequest {
  custom_booking_methods?: CustomBookingMethod[];
}

/** Schedule the shipment for pickup by the carrier service. */
export interface SchedulePickupRequest {
  /** Shipment ID */
  id?: string;
}

export interface SendFreightDocumentsForReturnShipmentRequest {
  email?: string;
  return_shipment_id?: string;
  site_id?: string;
}

/**
 * Shipment is the top level object in SOM. A shipment can be composed of
 * multiple parcels and each parcel can contain many deliveries. Only one
 * delivery can be active at a time.
 */
export interface Shipment {
  /** Addons that should be used for the shipment. */
  addons?: Addon[];
  /**
   * Address where the shipment will be dispatched from. Most often the
   * address of the warehouse [required].
   */
  address_from?: Address;
  /** Address where deliveries of this shipment should be returned to. */
  address_return?: Address;
  /**
   * Destination address. For example address of the service point or the click
   * and collect store [required].
   */
  address_to?: Address;
  /** ID of the carrier contract to be used for booking. */
  carrier_contract_id?: string;
  /** If the shipment is part of a consolidated shipment, this field will contain the details. */
  consolidated_shipment_details?: ConsolidatedShipmentDetails;
  /** Contents of shipment. Can be of different types - goods, transport orders and external orders. */
  contents?: Contents;
  /** Timestamp when shipment was created. */
  created_at?: string;
  /** Contains the customer information such as name, email, phone and address [required]. */
  customer_info?: CustomerInfo;
  /** Holds information about customs for the shipment. */
  customs?: Customs;
  /** DirectionType informs about initial shipment direction. */
  direction_type?: DirectionType;
  /**
   * Can be used to store a unique identifier from the merchant. For example
   * external order ID or external shipment ID.
   */
  external_id?: string;
  /** ID of the shipment (uuid). */
  id?: string;
  /** Use contents instead [deprecated] */
  line_items?: LineItem[];
  /**
   * Generic key-value object that can be used to attach additional
   * information to the shipment.
   */
  meta?: Record<string, string>;
  /** If the shipment is an outbound shipment, this field will contain the shipment id of the return shipment if it exists. */
  outbound_shipment_id?: string;
  /** Parcels associated with this shipment. */
  parcels?: Parcel[];
  /** If the shipment is a return shipment, this field will contain the shipment id of the outbound shipment if it exists. */
  return_shipment_id?: string;
  /**
   * Total value of the shipment including tax in cents. Example 10000 is 100 SEK.
   * @format uint64
   */
  shipment_value?: number;
  /** The date that the shipment will most likely be dispatched from the warehouse [required]. */
  shipping_date?: string;
  /** Site ID to which the shipment belongs to [internal]. */
  site_id?: string;
  /** Status of the shipment. Equivalent to the old Delivery.delivery_status. [required] */
  status?: ShipmentStatus;
  /** ID of a corresponding order. */
  tos_id?: string;
  /** [optional]  Defines who is billed for freight/transport charges. */
  transport_payer?: Payer;
  /** Timestamp when shipment was last updated. */
  updated_at?: string;
}

export interface ShipmentStatus {
  /** Used to attach a message to the current status. [optional] */
  message?: string;
  /** The type of the status. Used to determine the state of the shipment. [required] */
  type?: ShipmentStatusStatusType;
}

/**
 * - CREATED: CREATED is the initial state of the shipment.
 *  - BOOKED: BOOKED indicates that shipment has been booked, also known as having a label generated for it.
 *  - PICKUP_SCHEDULED: PICKUP_SCHEDULED indicates that shipment has been scheduled for pickup. The intricacies of the pickup is determined by the carrier and the site configuration.
 *  - CANCELED: CANCELED indicates that the delivery has been suspended and will not proceed.
 *  - INVALID_BOOKING: INVALID_BOOKING indicates that a booking failed due to a bad request to the carrier service.
 *  - CANCEL_FAILED: CANCEL_FAILED indicates that the shipment could not be canceled by the carrier
 * @default "UNKNOWN"
 */
export type ShipmentStatusStatusType =
  | "UNKNOWN"
  | "CREATED"
  | "BOOKED"
  | "PICKUP_SCHEDULED"
  | "CANCELED"
  | "INVALID_BOOKING"
  | "CANCEL_FAILED";

export interface StepActionLog {
  applied?: boolean;
  expression?: string;
  /**
   * Request object that is used to create a Shipment together with Parcels
   * and Deliveries all at once.
   */
  input?: CreateCompositeShipmentRequest;
  /**
   * Request object that is used to create a Shipment together with Parcels
   * and Deliveries all at once.
   */
  output?: CreateCompositeShipmentRequest;
  raw_error?: string;
}

export interface StepExpression {
  expression?: string;
}

export interface StepFilterLog {
  applied?: boolean;
  expression?: string;
  raw_error?: string;
}

export interface StepLog {
  actions?: StepActionLog[];
  filters?: StepFilterLog[];
  name?: string;
}

/**
 * Represents a booking strategy used by a delivery.
 * @default "STRATEGY_UNKNOWN"
 */
export type Strategy = "STRATEGY_UNKNOWN" | "STRATEGY_SCHEDULED" | "STRATEGY_IMMEDIATE";

export interface TaxIdentificationNumbers {
  /** Refers to the Employer Identification Number (EIN) for tax identification. */
  ein?: string;
  /**
   * Stands for Economic Operator Registration and Identification (EORI) number.
   * The EORI number is used for customs purposes to identify economic operators involved in the import or
   * export of goods within the European Union.
   */
  eori?: string;
  /** Refers to Their Majesty's Revenue and Customs (HMRC) identification. */
  hmrc?: string;
  /** Indicates the Import One-Stop Shop (IOSS) number. */
  ioss?: string;
  /** Represents the Permanent Account Number (PAN) used in certain jurisdictions. */
  pan?: string;
  /** Personal Customs Clearance Code : P+12digit number (Ex : P123456789012). Needed for shipments to South Korea */
  pccc?: string;
  /** Postponed VAT Accounting */
  pva?: string;
  /** Stands for Social Security Number (SSN) used in specific regions. */
  ssn?: string;
  /** Signifies the Taxpayer Identification Number (TIN) used for tax purposes. */
  tin?: string;
  /** UK Internal Market Scheme Number (Example: GBUKIMS123456789012202409011000) */
  ukims?: string;
  /** Stands for Value Added Tax (VAT) identification number. */
  vat?: string;
  /** Represents the Value of Exported Commodities (VOEC) number. */
  voec?: string;
}

export interface TestCustomBookingMethodsRequest {
  custom_booking_methods?: CustomBookingMethod[];
  shipments?: CreateCompositeShipmentRequest[];
}

export interface TestCustomBookingMethodsResponse {
  test_run_results?: CustomBookingsMethodTestRun[];
}

/** For internal use [internal] */
export interface TotalShipmentsCountResponse {
  /** @format uint64 */
  total_count?: number;
}

/** Not used [internal] */
export interface TransitTime {
  end?: string;
  start?: string;
}

/** Reference to goods defined by a transport order. */
export interface TransportOrderContentItem {
  /**
   * Additional reference which can be used freely by the client to tie together
   * a SOM shipment with an internal ID.
   */
  external_ref?: string;
  /** Transport order id. */
  tos_id?: string;
}

export interface TriggerPickupResponse {
  /** A list of records that have been succesfully booked. */
  records?: BookingRecord[];
}

/** Update a shipment request */
export interface UpdateConsolidatedShipmentRequest {
  /** Shipment to update, only pallets can be updated */
  shipment?: ConsolidatedShipment;
  /** update_mask marks what fields are to be updated. Only */
  update_mask?: string;
}

/** Returns the updated shipment */
export interface UpdateConsolidatedShipmentResponse {
  /** The updated shipment state */
  shipment?: ConsolidatedShipment;
}

/** Update shipment notes request can be sent for a shipment in any state [internal] */
export interface UpdateShipmentNotesRequest {
  notes?: string;
  shipment_id?: string;
}

/** For internal use [internal] */
export interface UpdateShipmentNotesResponse {
  /**
   * Shipment is the top level object in SOM. A shipment can be composed of
   * multiple parcels and each parcel can contain many deliveries. Only one
   * delivery can be active at a time.
   */
  shipment?: Shipment;
}

/** Update a shipment request */
export interface UpdateShipmentRequest {
  /** List of shipment addons. */
  addons?: Addon[];
  /**
   * Address where the shipment will be dispatched from. Most often the
   * address of the warehouse. [required]
   * Common address entity that used almost everywhere in Ingrid's API.
   */
  address_from?: Address;
  /**
   * Address where deliveries of this shipment should be returned to. [optional]
   * Common address entity that used almost everywhere in Ingrid's API.
   */
  address_return?: Address;
  /**
   * Destination address. For example address of the service point or the click
   * and collect store. [required]
   * Common address entity that used almost everywhere in Ingrid's API.
   */
  address_to?: Address;
  /** ID of the carrier contract to be used for booking. [optional] */
  carrier_contract_id?: string;
  /** Optional instructions to the courier */
  courier_instructions?: string;
  /** Contains the customer information such as name, email, phone and address. */
  customer_info?: CustomerInfo;
  /** Time range when the deliveries will most likely be delivered to the customer. */
  delivery_time?: DateTimeRange;
  /**
   * Can be used to store a unique identifier from the merchant. For example
   * external order ID or external shipment ID.
   */
  external_id?: string;
  /** ID of the pickup location where the parcels should be delivered to. */
  location_ref?: string;
  /**
   * Indicates the kind of pickup location [optional]
   * - UNKNOWN_PICKUP_LOCATION_TYPE: Location type is not known for some reason
   *  - LOCKER: Locker location type. Example Instabox or a DHL locker
   *  - STORE: Can be a merchant's store or any other store that handles logistics
   *  - POSTOFFICE: Postal office
   *  - MANNED: A manned service point
   */
  location_type?: PickupLocationType;
  /**
   * Generic key-value object that can be used to attach additional
   * information to the shipment.
   */
  meta?: Record<string, string>;
  /** Custom description (notes) that will be assigned to all parcels in the shipment. */
  parcel_free_text?: string;
  /** Shipment ID */
  shipment_id?: string;
  /**
   * Total value of the shipment including tax. Example 10000 is 100 SEK.
   * @format uint64
   */
  shipment_value?: number;
  /** The date that the shipment will most likely be dispatched from the warehouse. [required] */
  shipping_date?: string;
  /** Specific shipping product ID by which the generated parcels should be delivered. [required] */
  shipping_method?: string;
  /**
   * Weight in grams (g). If not set, the total weight of each parcel will be
   * calculated from its line items if that information is available. [deprecated]
   * @format uint64
   */
  weight?: number;
}

/** Returns the updated shipment */
export interface UpdateShipmentResponse {
  /**
   * The updated shipment state
   * Shipment is the top level object in SOM. A shipment can be composed of
   * multiple parcels and each parcel can contain many deliveries. Only one
   * delivery can be active at a time.
   */
  shipment?: Shipment;
}

export interface UpsertCustomsDeclarationRequest {
  /** Customs declaration information that will be upserted to the shipment. If empty field given, information about the customs declaration will be removed from the shipment. */
  customs_declaration?: GeneralCustomsDeclaration;
  /** The ID of the shipment for which customs declaration upserting. */
  shipment_id: string;
  /** The ID of the site to which this request belongs. */
  site_id: string;
}

export interface UpsertCustomsDeclarationResponse {
  /**
   * Shipment is the top level object in SOM. A shipment can be composed of
   * multiple parcels and each parcel can contain many deliveries. Only one
   * delivery can be active at a time.
   */
  shipment?: Shipment;
}

export interface Error {
  /** @format int32 */
  code?: number;
  details?: Any[];
  message?: string;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/v1/som" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title SOM API
 * @version 1.0
 * @baseUrl /v1/som
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  bookingsGet = {
    /**
     * No description
     *
     * @name SomGetBookingRecord
     * @request GET:/bookings.get
     * @secure
     */
    somGetBookingRecord: (
      query?: {
        id?: string;
        tracking_number?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetRecordResponse, Error>({
        path: `/bookings.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  bookingsTriggerPickup = {
    /**
     * No description
     *
     * @name SomTriggerPickup
     * @summary Manually trigger a BookPickup.
     * @request GET:/bookings.trigger_pickup
     * @secure
     */
    somTriggerPickup: (
      query?: {
        site_id?: string;
        shipping_method?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TriggerPickupResponse, Error>({
        path: `/bookings.trigger_pickup`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  consolidatedShipmentsBatchGet = {
    /**
     * No description
     *
     * @name SomBatchGetConsolidatedShipments
     * @summary Batch get Consolidated (also known as Bulk or Mother) shipments.
     * @request GET:/consolidated_shipments.batchGet
     * @secure
     */
    somBatchGetConsolidatedShipments: (
      query?: {
        consolidated_shipment_ids?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BatchGetConsolidatedShipmentResponse, Error>({
        path: `/consolidated_shipments.batchGet`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  consolidatedShipmentsBook = {
    /**
     * No description
     *
     * @name SomBookConsolidatedShipment
     * @summary Book a Consolidated (also known as Bulk or Mother) shipment with the carrier.
     * @request POST:/consolidated_shipments.book
     * @secure
     */
    somBookConsolidatedShipment: (body: BookConsolidatedShipmentRequest, params: RequestParams = {}) =>
      this.request<BookConsolidatedShipmentResponse, Error>({
        path: `/consolidated_shipments.book`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  consolidatedShipmentsGet = {
    /**
     * No description
     *
     * @name SomGetConsolidatedShipment
     * @summary Get a Consolidated (also known as Bulk or Mother) shipment.
     * @request GET:/consolidated_shipments.get
     * @secure
     */
    somGetConsolidatedShipment: (
      query?: {
        consolidated_shipment_id?: string;
        /**
         * control the level of expansion for sub resources
         *
         *  - SHIPMENTS_IDS_ONLY: Don't expand shipments, but include shipment id's in method shipment
         *  - SHIPMENTS_SUMMARY: Only expand top level fields of the shipments
         *  - SHIPMENTS_WITH_PARCELS: Expand top level fields and Parcels
         *  - SHIPMENTS_WITH_LINE_ITEMS: Expand top level fields and Items
         *  - SHIPMENTS_FULL: Fully expand shipments
         * @default "SHIPMENTS_IDS_ONLY"
         */
        export?:
          | "SHIPMENTS_IDS_ONLY"
          | "SHIPMENTS_SUMMARY"
          | "SHIPMENTS_WITH_PARCELS"
          | "SHIPMENTS_WITH_LINE_ITEMS"
          | "SHIPMENTS_FULL";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetConsolidatedShipmentResponse, Error>({
        path: `/consolidated_shipments.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  consolidatedShipmentsList = {
    /**
     * No description
     *
     * @name SomListConsolidatedShipments
     * @summary Return a list of consolidated shipments that belong to given order.
     * @request POST:/consolidated_shipments.list
     * @secure
     */
    somListConsolidatedShipments: (body: ListConsolidatedShipmentsRequest, params: RequestParams = {}) =>
      this.request<ListConsolidatedShipmentsResponse, Error>({
        path: `/consolidated_shipments.list`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  consolidatedShipmentsOpen = {
    /**
     * No description
     *
     * @name SomOpenConsolidatedShipment
     * @summary Open a Consolidated (also known as Bulk or Mother) shipment with the carrier.
     * @request POST:/consolidated_shipments.open
     * @secure
     */
    somOpenConsolidatedShipment: (body: OpenConsolidatedShipmentRequest, params: RequestParams = {}) =>
      this.request<OpenConsolidatedShipmentResponse, Error>({
        path: `/consolidated_shipments.open`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  consolidatedShipmentsUpdate = {
    /**
     * No description
     *
     * @name SomUpdateConsolidatedShipment
     * @summary Updates a consolidated shipment.
     * @request POST:/consolidated_shipments.update
     * @secure
     */
    somUpdateConsolidatedShipment: (body: UpdateConsolidatedShipmentRequest, params: RequestParams = {}) =>
      this.request<UpdateConsolidatedShipmentResponse, Error>({
        path: `/consolidated_shipments.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  consolidatedShipmentsCount = {
    /**
     * No description
     *
     * @name SomCountConsolidatedShipments
     * @summary Return counts of consolidated shipments for multiple filtering criteria.
     * @request POST:/consolidated_shipments:count
     * @secure
     */
    somCountConsolidatedShipments: (
      count: string,
      body: CountConsolidatedShipmentsRequest,
      params: RequestParams = {},
    ) =>
      this.request<CountConsolidatedShipmentsResponse, Error>({
        path: `/consolidated_shipments${count}`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customBookingMethodsDeleteDraft = {
    /**
     * No description
     *
     * @name SomDeleteDraftCustomBookingMethods
     * @request POST:/custom_booking_methods.deleteDraft
     * @secure
     */
    somDeleteDraftCustomBookingMethods: (body: DeleteDraftCustomBookingMethodRequest, params: RequestParams = {}) =>
      this.request<object, Error>({
        path: `/custom_booking_methods.deleteDraft`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customBookingMethodsGet = {
    /**
     * No description
     *
     * @name SomGetCustomBookingMethod
     * @request GET:/custom_booking_methods.get
     * @secure
     */
    somGetCustomBookingMethod: (
      query?: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCustomBookingMethodResponse, Error>({
        path: `/custom_booking_methods.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  customBookingMethodsList = {
    /**
     * No description
     *
     * @name SomListCustomBookingMethods
     * @request POST:/custom_booking_methods.list
     * @secure
     */
    somListCustomBookingMethods: (body: ListCustomBookingMethodsRequest, params: RequestParams = {}) =>
      this.request<ListCustomBookingMethodsResponse, Error>({
        path: `/custom_booking_methods.list`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customBookingMethodsPrompt = {
    /**
     * No description
     *
     * @name SomAiCreateCustomBookingMethods
     * @request POST:/custom_booking_methods.prompt
     * @secure
     */
    somAiCreateCustomBookingMethods: (body: AICreateCustomBookingMethodsRequest, params: RequestParams = {}) =>
      this.request<AICreateCustomBookingMethodsResponse, Error>({
        path: `/custom_booking_methods.prompt`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customBookingMethodsPublish = {
    /**
     * No description
     *
     * @name SomPublishCustomBookingMethods
     * @request POST:/custom_booking_methods.publish
     * @secure
     */
    somPublishCustomBookingMethods: (body: PublishCustomBookingMethodsRequest, params: RequestParams = {}) =>
      this.request<object, Error>({
        path: `/custom_booking_methods.publish`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customBookingMethodsSaveDraft = {
    /**
     * No description
     *
     * @name SomSaveDraftCustomBookingMethods
     * @request POST:/custom_booking_methods.saveDraft
     * @secure
     */
    somSaveDraftCustomBookingMethods: (body: SaveDraftCustomBookingMethodsRequest, params: RequestParams = {}) =>
      this.request<object, Error>({
        path: `/custom_booking_methods.saveDraft`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customBookingMethodsTest = {
    /**
     * No description
     *
     * @name SomTestCustomBookingMethods
     * @request POST:/custom_booking_methods.test
     * @secure
     */
    somTestCustomBookingMethods: (body: TestCustomBookingMethodsRequest, params: RequestParams = {}) =>
      this.request<TestCustomBookingMethodsResponse, Error>({
        path: `/custom_booking_methods.test`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customsDeclarationUpsert = {
    /**
     * No description
     *
     * @name SomUpsertCustomsDeclaration
     * @summary Add or update (overwrite if it's already exists) customs declaration to existing, with not booked parcels (see 'Book Parcels'), shipment.
     * @request POST:/customs_declaration.upsert
     * @secure
     */
    somUpsertCustomsDeclaration: (body: UpsertCustomsDeclarationRequest, params: RequestParams = {}) =>
      this.request<UpsertCustomsDeclarationResponse, Error>({
        path: `/customs_declaration.upsert`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  deliveriesBookPickup = {
    /**
     * No description
     *
     * @name SomBookPickup
     * @summary Notify the shipping company about the delivery.
     * @request POST:/deliveries.bookPickup
     * @secure
     */
    somBookPickup: (body: BookPickupRequest, params: RequestParams = {}) =>
      this.request<BookPickupResponse, Error>({
        path: `/deliveries.bookPickup`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  deliveriesCancel = {
    /**
     * No description
     *
     * @name SomCancelDelivery
     * @summary Cancels a delivery by its tracking number.
     * @request POST:/deliveries.cancel
     * @secure
     */
    somCancelDelivery: (body: CancelDeliveryRequest, params: RequestParams = {}) =>
      this.request<object, Error>({
        path: `/deliveries.cancel`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  deliveriesGet = {
    /**
     * No description
     *
     * @name SomGetDelivery
     * @summary Return a Delivery either by id or tracking number.
     * @request GET:/deliveries.get
     * @secure
     */
    somGetDelivery: (
      query?: {
        /** Delivery ID */
        id?: string;
        /** Delivery tracking number */
        tracking_number?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDeliveryResponse, Error>({
        path: `/deliveries.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  fetchPickupLocations = {
    /**
     * No description
     *
     * @name SomFetchPickupLocations
     * @summary Fetch pickup locations for a shipment
     * @request POST:/fetch_pickup_locations
     * @secure
     */
    somFetchPickupLocations: (body: FetchPickupLocationsRequest, params: RequestParams = {}) =>
      this.request<FetchPickupLocationsResponse, Error>({
        path: `/fetch_pickup_locations`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  pendingShipmentsCount = {
    /**
     * No description
     *
     * @name SomCountPendingShipments
     * @request POST:/pending_shipments.count
     * @secure
     */
    somCountPendingShipments: (body: CountPendingShipmentsRequest, params: RequestParams = {}) =>
      this.request<CountPendingShipmentsResponse, Error>({
        path: `/pending_shipments.count`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  pendingShipmentsGet = {
    /**
     * No description
     *
     * @name SomGetPendingShipment
     * @summary Return the shipment by specifiying a shipmentID or deliveryID of that shipment.
     * @request GET:/pending_shipments.get
     * @secure
     */
    somGetPendingShipment: (
      query?: {
        /** Shipment ID */
        lookup_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPendingShipmentResponse, Error>({
        path: `/pending_shipments.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  pendingShipmentsList = {
    /**
     * No description
     *
     * @name SomListPendingShipments
     * @request POST:/pending_shipments.list
     * @secure
     */
    somListPendingShipments: (body: ListPendingShipmentsRequest, params: RequestParams = {}) =>
      this.request<ListPendingShipmentsResponse, Error>({
        path: `/pending_shipments.list`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentsAddParcel = {
    /**
 * No description
 *
 * @name SomAddParcel
 * @summary Add parcel to existing, not yet booked for pickup, shipment. If the shipment is booked then the
parcel will be booked as well. If a return shipment is connected with the provided shipment,
the parcel will be added to that shipment as well.
 * @request POST:/shipments.add_parcel
 * @secure
 */
    somAddParcel: (body: AddParcelRequest, params: RequestParams = {}) =>
      this.request<AddParcelResponse, Error>({
        path: `/shipments.add_parcel`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentsBookParcels = {
    /**
 * No description
 *
 * @name SomBookParcels
 * @summary Create a booking with the shipping company. Tracking
numbers, tracking links and shipping labels are generated.
 * @request POST:/shipments.bookParcels
 * @secure
 */
    somBookParcels: (body: BookParcelsRequest, params: RequestParams = {}) =>
      this.request<BookParcelsResponse, Error>({
        path: `/shipments.bookParcels`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentsBookParcelsBulk = {
    /**
     * No description
     *
     * @name SomBookParcelsBulk
     * @summary Same as BookParcels, but for multiple shipment at once.
     * @request POST:/shipments.book_parcels_bulk
     * @secure
     */
    somBookParcelsBulk: (body: BookParcelsBulkRequest, params: RequestParams = {}) =>
      this.request<BookParcelsBulkResponse, Error>({
        path: `/shipments.book_parcels_bulk`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentsCancel = {
    /**
 * No description
 *
 * @name SomCancelShipment
 * @summary Cancels a shipment by its id.
Return nothing if canceled successfully. Shipment status will be updated to CANCELED.
If we fail to cancel the shipment, an error will be returned.
If the carrier denied the cancellation, or we where unable to cancel, the status of the shipment will be updated to FAILED_TO_CANCEL.
 * @request POST:/shipments.cancel
 * @secure
 */
    somCancelShipment: (body: CancelShipmentRequest, params: RequestParams = {}) =>
      this.request<object, Error>({
        path: `/shipments.cancel`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentsCreate = {
    /**
     * No description
     *
     * @name SomCreateCompositeShipment
     * @summary Create a Shipment together with parcels and deliveries.
     * @request POST:/shipments.create
     * @secure
     */
    somCreateCompositeShipment: (body: CreateCompositeShipmentRequest, params: RequestParams = {}) =>
      this.request<CreateCompositeShipmentResponse, Error>({
        path: `/shipments.create`,
        method: "POST",
        body: body,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shipmentsCreateAndBook = {
    /**
     * No description
     *
     * @name SomCreateAndBookShipment
     * @summary Create a shipment together with parcels and deliveries, then generate labels and tracking numbers and finally book pickup for all deliveries.
     * @request POST:/shipments.createAndBook
     * @secure
     */
    somCreateAndBookShipment: (body: CreateCompositeShipmentRequest, params: RequestParams = {}) =>
      this.request<CreateCompositeShipmentResponse, Error>({
        path: `/shipments.createAndBook`,
        method: "POST",
        body: body,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shipmentsCreateAndBookFromSession = {
    /**
     * No description
     *
     * @name SomCreateAndBookShipmentFromSession
     * @summary Create a shipment together with parcels and deliveries, then generate labels and tracking numbers and finally book pickup for all deliveries based on the information in a cos session and some additional information.
     * @request POST:/shipments.createAndBookFromSession
     * @secure
     */
    somCreateAndBookShipmentFromSession: (body: CreateCompositeShipmentFromRequest, params: RequestParams = {}) =>
      this.request<CreateCompositeShipmentResponse, Error>({
        path: `/shipments.createAndBookFromSession`,
        method: "POST",
        body: body,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shipmentsCreateFrom = {
    /**
     * No description
     *
     * @name SomCreateCompositeShipmentFrom
     * @summary Create a shipment with parcels and deliveries based on the information in a cos session and some additional information.
     * @request POST:/shipments.createFrom
     * @secure
     */
    somCreateCompositeShipmentFrom: (body: CreateCompositeShipmentFromRequest, params: RequestParams = {}) =>
      this.request<CreateCompositeShipmentResponse, Error>({
        path: `/shipments.createFrom`,
        method: "POST",
        body: body,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shipmentsCreateFromOrder = {
    /**
 * No description
 *
 * @name SomCreateCompositeShipmentFromOrder
 * @summary Deprecated: use CreateCompositeShipment instead.
Create a shipment with parcels and deliveries based on the information stored in an order and some additional attributes. [deprecated]
 * @request POST:/shipments.createFromOrder
 * @secure
 */
    somCreateCompositeShipmentFromOrder: (body: CreateCompositeShipmentFromOrderRequest, params: RequestParams = {}) =>
      this.request<CreateCompositeShipmentResponse, Error>({
        path: `/shipments.createFromOrder`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentsGet = {
    /**
     * No description
     *
     * @name SomGetShipment
     * @summary Return the shipment by specifiying a shipmentID or deliveryID of that shipment.
     * @request GET:/shipments.get
     * @secure
     */
    somGetShipment: (
      query?: {
        /** Shipment ID */
        id?: string;
        delivery_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetShipmentResponse, Error>({
        path: `/shipments.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shipmentsHydrate = {
    /**
 * No description
 *
 * @name SomHydrateShipment
 * @summary HydrateShipment takes a request and runs the manipulations on CreateCompositeShipmentRequest
done before the shipment is created. This dry-run is useful when you want to see the result of
the manipulations before the shipment is created. Hydrate does not validate the shipment.
 * @request POST:/shipments.hydrate
 * @secure
 */
    somHydrateShipment: (body: CreateCompositeShipmentRequest, params: RequestParams = {}) =>
      this.request<HydrateShipmentResponse, Error>({
        path: `/shipments.hydrate`,
        method: "POST",
        body: body,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shipmentsList = {
    /**
     * No description
     *
     * @name SomListShipments
     * @summary Return a paginated list of shipments matching filters.
     * @request POST:/shipments.list
     * @secure
     */
    somListShipments: (body: ListShipmentsRequest, params: RequestParams = {}) =>
      this.request<ListShipmentsResponse, Error>({
        path: `/shipments.list`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentsSchedulePickup = {
    /**
     * No description
     *
     * @name SomSchedulePickup
     * @summary Schedule the shipment for pickup by the carrier service.
     * @request POST:/shipments.schedulePickup
     * @secure
     */
    somSchedulePickup: (body: SchedulePickupRequest, params: RequestParams = {}) =>
      this.request<object, Error>({
        path: `/shipments.schedulePickup`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentsSendFreightDocuments = {
    /**
     * No description
     *
     * @name SomSendFreightDocumentsForReturnShipment
     * @summary Send freight documents for return shipment.
     * @request POST:/shipments.send_freight_documents
     * @secure
     */
    somSendFreightDocumentsForReturnShipment: (
      body: SendFreightDocumentsForReturnShipmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<object, Error>({
        path: `/shipments.send_freight_documents`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentsTotalCount = {
    /**
     * No description
     *
     * @name SomTotalShipmentsCount
     * @summary Get a total number of shipments.
     * @request GET:/shipments.totalCount
     * @secure
     */
    somTotalShipmentsCount: (params: RequestParams = {}) =>
      this.request<TotalShipmentsCountResponse, Error>({
        path: `/shipments.totalCount`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shipmentsUpdate = {
    /**
     * No description
     *
     * @name SomUpdateShipment
     * @summary Updates a shipment. Parcels and deliveries will also be updated if applicable.
     * @request POST:/shipments.update
     * @secure
     */
    somUpdateShipment: (body: UpdateShipmentRequest, params: RequestParams = {}) =>
      this.request<UpdateShipmentResponse, Error>({
        path: `/shipments.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentsUpdateNotes = {
    /**
     * No description
     *
     * @name SomUpdateShipmentNotes
     * @summary Updates the shipment notes.
     * @request POST:/shipments.updateNotes
     * @secure
     */
    somUpdateShipmentNotes: (body: UpdateShipmentNotesRequest, params: RequestParams = {}) =>
      this.request<UpdateShipmentNotesResponse, Error>({
        path: `/shipments.updateNotes`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
